//  Product Ownership Checker
//  Checks if the current user owns the product by calling the /api/access endpoint

const apiHost = `${window.kbconfig.API_URL}/api/`
const accessEndpoint = apiHost + 'Entitlements/user-access'

// API call to check user access and owned kits
async function checkAccess() {
  try {
    const response = await fetch(accessEndpoint, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.ok) {
      const data = await response.json()
      return { success: true, kitSlugs: data.kit_slugs || [] }
    } else {
      return { success: false, kitSlugs: [] }
    }
  } catch (error) {
    console.error('Failed to check access:', error)
    return { success: false, kitSlugs: [] }
  }
}

// Check if product slug is in the list of owned slugs
function isProductOwned(productSlug, ownedKitSlugs) {
  if (!productSlug) return false
  return ownedKitSlugs.includes(productSlug)
}

// UI State management functions
function showLoadingState() {
  const loadingContainer = document.getElementById('ownership-loading')
  const purchaseContainer = document.getElementById('purchase-section')
  const ownedContainer = document.getElementById('owned-section')

  if (loadingContainer) loadingContainer.style.display = 'block'
  if (purchaseContainer) purchaseContainer.style.display = 'none'
  if (ownedContainer) ownedContainer.style.display = 'none'
}

function showOwnedState() {
  const loadingContainer = document.getElementById('ownership-loading')
  const purchaseContainer = document.getElementById('purchase-section')
  const ownedContainer = document.getElementById('owned-section')

  if (loadingContainer) loadingContainer.style.display = 'none'
  if (purchaseContainer) purchaseContainer.style.display = 'none'
  if (ownedContainer) ownedContainer.style.display = 'block'
}

function showPurchaseState() {
  const loadingContainer = document.getElementById('ownership-loading')
  const purchaseContainer = document.getElementById('purchase-section')
  const ownedContainer = document.getElementById('owned-section')

  if (loadingContainer) loadingContainer.style.display = 'none'
  if (purchaseContainer) purchaseContainer.style.display = 'block'
  if (ownedContainer) ownedContainer.style.display = 'none'
}

// Main initialization function
async function initializeProductOwnership() {
  const sidebar = document.querySelector('.pdp-sidebar')
  if (!sidebar) return

  const productSlug = sidebar.dataset.productSlug

  if (!productSlug) {
    console.warn('No product slug found on sidebar')
    showPurchaseState()
    return
  }

  showLoadingState()

  const { success, kitSlugs } = await checkAccess()

  if (success && isProductOwned(productSlug, kitSlugs)) {
    showOwnedState()
  } else {
    showPurchaseState()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.pdp-sidebar')) return
  initializeProductOwnership()
})
